import Vue from 'vue'

// ---------- Dummy Users ----------
const users = [
  { _id: 'u1', name: 'Rahul Sharma', avatar: '', email: 'rahul@finfi.com', department: 'Collections' },
  { _id: 'u2', name: 'Priya Patel', avatar: '', email: 'priya@finfi.com', department: 'Operations' },
  { _id: 'u3', name: 'Amit Kumar', avatar: '', email: 'amit@finfi.com', department: 'Sales' },
  { _id: 'u4', name: 'Sneha Reddy', avatar: '', email: 'sneha@finfi.com', department: 'HR' },
  { _id: 'u5', name: 'Vikram Singh', avatar: '', email: 'vikram@finfi.com', department: 'Finance' },
  { _id: 'u6', name: 'Ananya Das', avatar: '', email: 'ananya@finfi.com', department: 'Collections' },
  { _id: 'u7', name: 'Rohan Mehta', avatar: '', email: 'rohan@finfi.com', department: 'Technology' },
  { _id: 'u8', name: 'Kavita Joshi', avatar: '', email: 'kavita@finfi.com', department: 'Compliance' },
  { _id: 'u9', name: 'Deepak Verma', avatar: '', email: 'deepak@finfi.com', department: 'Sales' },
  { _id: 'u10', name: 'Meera Nair', avatar: '', email: 'meera@finfi.com', department: 'Operations' }
]

// ---------- Dummy Courses ----------
const courses = [
  {
    _id: 'c1',
    title: 'Loan Collection Best Practices',
    description: 'Master the art of effective loan collection with proven strategies, negotiation techniques, and compliance guidelines for field agents.',
    category: 'Compliance',
    difficulty: 'Beginner',
    instructor: 'Rajesh Khanna',
    thumbnail: '',
    createdAt: '2026-05-10T10:00:00Z',
    enrolledUsers: ['u1', 'u2', 'u3', 'u6', 'u8'],
    lessons: [
      { _id: 'l1-1', title: 'Introduction to Loan Collections', description: 'Overview of the loan collection lifecycle and key terminology.', duration: '12:30', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4', order: 1 },
      { _id: 'l1-2', title: 'Understanding RBI Guidelines', description: 'Deep dive into regulatory requirements for ethical collection practices.', duration: '18:45', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4', order: 2 },
      { _id: 'l1-3', title: 'Customer Communication Techniques', description: 'How to communicate effectively with defaulting borrowers.', duration: '15:20', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4', order: 3 },
      { _id: 'l1-4', title: 'Negotiation Strategies', description: 'Proven negotiation frameworks for settlement discussions.', duration: '22:10', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4', order: 4 },
      { _id: 'l1-5', title: 'Legal Aspects & Compliance', description: 'Legal boundaries and do\'s and don\'ts during the collection process.', duration: '20:00', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4', order: 5 },
      { _id: 'l1-6', title: 'Field Visit Protocol', description: 'Standard operating procedures for field visits and documentation.', duration: '14:55', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4', order: 6 }
    ]
  },
  {
    _id: 'c2',
    title: 'Advanced CRM & Lead Management',
    description: 'Learn how to leverage the CRM system for efficient lead tracking, conversion optimization, and pipeline management.',
    category: 'Product Training',
    difficulty: 'Intermediate',
    instructor: 'Sneha Kapoor',
    thumbnail: '',
    createdAt: '2026-04-15T10:00:00Z',
    enrolledUsers: ['u3', 'u4', 'u5', 'u9'],
    lessons: [
      { _id: 'l2-1', title: 'CRM Dashboard Overview', description: 'Navigate the CRM dashboard and understand key metrics.', duration: '10:15', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4', order: 1 },
      { _id: 'l2-2', title: 'Lead Capture & Assignment', description: 'Setting up automated lead capture and assignment rules.', duration: '16:30', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4', order: 2 },
      { _id: 'l2-3', title: 'Pipeline Management', description: 'Building and managing your sales pipeline effectively.', duration: '19:45', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4', order: 3 },
      { _id: 'l2-4', title: 'Reporting & Analytics', description: 'Creating custom reports and analyzing conversion data.', duration: '14:20', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4', order: 4 },
      { _id: 'l2-5', title: 'Automation & Workflows', description: 'Setting up automated workflows for lead nurturing.', duration: '21:00', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4', order: 5 }
    ]
  },
  {
    _id: 'c3',
    title: 'Financial Product Knowledge',
    description: 'Comprehensive training on all financial products including personal loans, business loans, credit lines, and insurance products.',
    category: 'Product Training',
    difficulty: 'Beginner',
    instructor: 'Anil Deshmukh',
    thumbnail: '',
    createdAt: '2026-03-20T10:00:00Z',
    enrolledUsers: ['u1', 'u2', 'u3', 'u4', 'u5', 'u6', 'u9', 'u10'],
    lessons: [
      { _id: 'l3-1', title: 'Personal Loan Products', description: 'Understanding personal loan products, eligibility, and documentation.', duration: '17:30', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4', order: 1 },
      { _id: 'l3-2', title: 'Business Loan Products', description: 'Business loan categories, terms, and underwriting criteria.', duration: '20:15', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4', order: 2 },
      { _id: 'l3-3', title: 'Credit Line Products', description: 'Revolving credit facilities and their management.', duration: '13:45', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4', order: 3 },
      { _id: 'l3-4', title: 'Insurance Products', description: 'Insurance product bundling and cross-selling strategies.', duration: '15:50', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4', order: 4 },
      { _id: 'l3-5', title: 'Interest Rate Calculations', description: 'How to calculate EMI, flat vs reducing rates, and fee structures.', duration: '25:00', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4', order: 5 },
      { _id: 'l3-6', title: 'KYC & Documentation', description: 'KYC requirements and documentation checklist for each product.', duration: '18:20', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4', order: 6 },
      { _id: 'l3-7', title: 'Comparison & Cross-Selling', description: 'Product comparison techniques and cross-selling strategies.', duration: '16:10', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4', order: 7 }
    ]
  },
  {
    _id: 'c4',
    title: 'Workplace Communication & Soft Skills',
    description: 'Enhance your professional communication, presentation skills, and team collaboration abilities for better workplace performance.',
    category: 'Soft Skills',
    difficulty: 'Beginner',
    instructor: 'Meera Nambiar',
    thumbnail: '',
    createdAt: '2026-06-01T10:00:00Z',
    enrolledUsers: ['u1', 'u4', 'u7', 'u8', 'u10'],
    lessons: [
      { _id: 'l4-1', title: 'Effective Email Writing', description: 'Writing clear, professional emails that get responses.', duration: '11:30', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4', order: 1 },
      { _id: 'l4-2', title: 'Presentation Skills', description: 'Creating and delivering impactful presentations.', duration: '19:15', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4', order: 2 },
      { _id: 'l4-3', title: 'Active Listening', description: 'Techniques for better listening and understanding in conversations.', duration: '13:40', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4', order: 3 },
      { _id: 'l4-4', title: 'Conflict Resolution', description: 'Managing and resolving workplace conflicts professionally.', duration: '17:25', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4', order: 4 }
    ]
  },
  {
    _id: 'c5',
    title: 'Data Privacy & Security Compliance',
    description: 'Essential training on data protection regulations, cybersecurity best practices, and organizational security policies.',
    category: 'Compliance',
    difficulty: 'Intermediate',
    instructor: 'Sanjay Verma',
    thumbnail: '',
    createdAt: '2026-05-25T10:00:00Z',
    enrolledUsers: ['u1', 'u2', 'u3', 'u4', 'u5', 'u6', 'u7', 'u8', 'u9', 'u10'],
    lessons: [
      { _id: 'l5-1', title: 'Data Protection Act Overview', description: 'Understanding the Digital Personal Data Protection Act 2023.', duration: '20:00', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4', order: 1 },
      { _id: 'l5-2', title: 'Handling Customer Data', description: 'Best practices for collecting, storing, and processing customer data.', duration: '16:30', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4', order: 2 },
      { _id: 'l5-3', title: 'Cybersecurity Basics', description: 'Password hygiene, phishing awareness, and safe browsing.', duration: '14:15', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4', order: 3 },
      { _id: 'l5-4', title: 'Incident Reporting', description: 'How to identify and report security incidents.', duration: '12:45', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4', order: 4 },
      { _id: 'l5-5', title: 'Access Control & Authorization', description: 'Role-based access control and principle of least privilege.', duration: '18:30', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4', order: 5 }
    ]
  },
  {
    _id: 'c6',
    title: 'Leadership & Team Management',
    description: 'Develop leadership capabilities, learn team management frameworks, and build high-performing teams.',
    category: 'Soft Skills',
    difficulty: 'Advanced',
    instructor: 'Dr. Arvind Rao',
    thumbnail: '',
    createdAt: '2026-06-10T10:00:00Z',
    enrolledUsers: ['u2', 'u5', 'u7'],
    lessons: [
      { _id: 'l6-1', title: 'Leadership Styles', description: 'Understanding different leadership styles and when to apply them.', duration: '22:00', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4', order: 1 },
      { _id: 'l6-2', title: 'Building High-Performance Teams', description: 'Strategies for team formation, development, and motivation.', duration: '25:30', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4', order: 2 },
      { _id: 'l6-3', title: 'Performance Management', description: 'Setting goals, providing feedback, and conducting reviews.', duration: '19:45', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4', order: 3 },
      { _id: 'l6-4', title: 'Decision Making Frameworks', description: 'Data-driven decision making and strategic thinking.', duration: '21:15', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4', order: 4 },
      { _id: 'l6-5', title: 'Change Management', description: 'Leading organizational change and managing resistance.', duration: '18:50', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4', order: 5 },
      { _id: 'l6-6', title: 'Mentoring & Coaching', description: 'Effective mentoring and coaching techniques for team growth.', duration: '16:30', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4', order: 6 }
    ]
  },
  {
    _id: 'c7',
    title: 'Mobile App & Field Operations',
    description: 'Complete guide to using the mobile field app for attendance, task management, customer visits, and real-time reporting.',
    category: 'Technical',
    difficulty: 'Beginner',
    instructor: 'Kiran Rao',
    thumbnail: '',
    createdAt: '2026-06-18T10:00:00Z',
    enrolledUsers: ['u1', 'u3', 'u6', 'u9', 'u10'],
    lessons: [
      { _id: 'l7-1', title: 'App Installation & Setup', description: 'Downloading, installing, and configuring the field app.', duration: '8:30', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4', order: 1 },
      { _id: 'l7-2', title: 'Attendance & Check-in', description: 'Using GPS-based attendance and selfie check-in features.', duration: '10:15', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4', order: 2 },
      { _id: 'l7-3', title: 'Task Management', description: 'Viewing, updating, and completing assigned tasks.', duration: '14:30', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4', order: 3 },
      { _id: 'l7-4', title: 'Customer Visit Reporting', description: 'Recording visit details, uploading photos, and submitting reports.', duration: '12:45', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4', order: 4 },
      { _id: 'l7-5', title: 'Offline Mode & Sync', description: 'Working offline and syncing data when back online.', duration: '9:20', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4', order: 5 }
    ]
  },
  {
    _id: 'c8',
    title: 'Anti-Money Laundering (AML) Training',
    description: 'Mandatory compliance training covering AML regulations, suspicious transaction identification, and reporting obligations.',
    category: 'Compliance',
    difficulty: 'Advanced',
    instructor: 'Adv. Pooja Malhotra',
    thumbnail: '',
    createdAt: '2026-06-20T10:00:00Z',
    enrolledUsers: ['u1', 'u2', 'u5', 'u8'],
    lessons: [
      { _id: 'l8-1', title: 'AML Regulatory Framework', description: 'Overview of PMLA and international AML standards.', duration: '24:00', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4', order: 1 },
      { _id: 'l8-2', title: 'Customer Due Diligence (CDD)', description: 'KYC verification, enhanced due diligence, and PEP screening.', duration: '20:30', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4', order: 2 },
      { _id: 'l8-3', title: 'Suspicious Transaction Reporting', description: 'Identifying red flags and filing STR/CTR reports.', duration: '22:15', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4', order: 3 },
      { _id: 'l8-4', title: 'Case Studies & Scenarios', description: 'Real-world case studies of money laundering schemes.', duration: '26:45', videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4', order: 4 }
    ]
  }
]

// ---------- User Progress (completion map) ----------
// Structure: { lessonId: { completedAt: Date, userId, courseId } }
const progressEntries = [
  // Course 1 progress
  { lessonId: 'l1-1', userId: 'u1', courseId: 'c1', completedAt: '2026-06-01T10:30:00Z' },
  { lessonId: 'l1-2', userId: 'u1', courseId: 'c1', completedAt: '2026-06-02T14:00:00Z' },
  { lessonId: 'l1-3', userId: 'u1', courseId: 'c1', completedAt: '2026-06-03T09:15:00Z' },
  { lessonId: 'l1-1', userId: 'u2', courseId: 'c1', completedAt: '2026-06-05T11:00:00Z' },
  { lessonId: 'l1-2', userId: 'u2', courseId: 'c1', completedAt: '2026-06-06T15:30:00Z' },
  { lessonId: 'l1-1', userId: 'u3', courseId: 'c1', completedAt: '2026-06-07T10:00:00Z' },
  { lessonId: 'l1-1', userId: 'u6', courseId: 'c1', completedAt: '2026-06-08T12:00:00Z' },
  { lessonId: 'l1-2', userId: 'u6', courseId: 'c1', completedAt: '2026-06-09T13:00:00Z' },
  { lessonId: 'l1-3', userId: 'u6', courseId: 'c1', completedAt: '2026-06-10T14:00:00Z' },
  { lessonId: 'l1-4', userId: 'u6', courseId: 'c1', completedAt: '2026-06-11T15:00:00Z' },
  { lessonId: 'l1-5', userId: 'u6', courseId: 'c1', completedAt: '2026-06-12T16:00:00Z' },
  { lessonId: 'l1-6', userId: 'u6', courseId: 'c1', completedAt: '2026-06-13T17:00:00Z' },
  // Course 2 progress
  { lessonId: 'l2-1', userId: 'u3', courseId: 'c2', completedAt: '2026-06-10T10:00:00Z' },
  { lessonId: 'l2-2', userId: 'u3', courseId: 'c2', completedAt: '2026-06-11T11:00:00Z' },
  { lessonId: 'l2-3', userId: 'u3', courseId: 'c2', completedAt: '2026-06-12T12:00:00Z' },
  { lessonId: 'l2-1', userId: 'u5', courseId: 'c2', completedAt: '2026-06-10T14:00:00Z' },
  { lessonId: 'l2-1', userId: 'u9', courseId: 'c2', completedAt: '2026-06-15T09:00:00Z' },
  { lessonId: 'l2-2', userId: 'u9', courseId: 'c2', completedAt: '2026-06-16T10:00:00Z' },
  // Course 3 progress
  { lessonId: 'l3-1', userId: 'u1', courseId: 'c3', completedAt: '2026-06-01T10:00:00Z' },
  { lessonId: 'l3-2', userId: 'u1', courseId: 'c3', completedAt: '2026-06-02T11:00:00Z' },
  { lessonId: 'l3-3', userId: 'u1', courseId: 'c3', completedAt: '2026-06-03T12:00:00Z' },
  { lessonId: 'l3-4', userId: 'u1', courseId: 'c3', completedAt: '2026-06-04T13:00:00Z' },
  { lessonId: 'l3-5', userId: 'u1', courseId: 'c3', completedAt: '2026-06-05T14:00:00Z' },
  { lessonId: 'l3-6', userId: 'u1', courseId: 'c3', completedAt: '2026-06-06T15:00:00Z' },
  { lessonId: 'l3-7', userId: 'u1', courseId: 'c3', completedAt: '2026-06-07T16:00:00Z' },
  { lessonId: 'l3-1', userId: 'u4', courseId: 'c3', completedAt: '2026-06-12T10:00:00Z' },
  { lessonId: 'l3-2', userId: 'u4', courseId: 'c3', completedAt: '2026-06-13T11:00:00Z' },
  { lessonId: 'l3-1', userId: 'u10', courseId: 'c3', completedAt: '2026-06-20T09:00:00Z' },
  // Course 4 progress
  { lessonId: 'l4-1', userId: 'u1', courseId: 'c4', completedAt: '2026-06-15T10:00:00Z' },
  { lessonId: 'l4-2', userId: 'u1', courseId: 'c4', completedAt: '2026-06-16T11:00:00Z' },
  { lessonId: 'l4-1', userId: 'u7', courseId: 'c4', completedAt: '2026-06-18T14:00:00Z' },
  { lessonId: 'l4-2', userId: 'u7', courseId: 'c4', completedAt: '2026-06-19T15:00:00Z' },
  { lessonId: 'l4-3', userId: 'u7', courseId: 'c4', completedAt: '2026-06-20T16:00:00Z' },
  { lessonId: 'l4-4', userId: 'u7', courseId: 'c4', completedAt: '2026-06-21T17:00:00Z' },
  // Course 5 progress
  { lessonId: 'l5-1', userId: 'u1', courseId: 'c5', completedAt: '2026-06-10T10:00:00Z' },
  { lessonId: 'l5-2', userId: 'u1', courseId: 'c5', completedAt: '2026-06-11T11:00:00Z' },
  { lessonId: 'l5-1', userId: 'u2', courseId: 'c5', completedAt: '2026-06-12T10:00:00Z' },
  { lessonId: 'l5-1', userId: 'u7', courseId: 'c5', completedAt: '2026-06-14T14:00:00Z' },
  { lessonId: 'l5-2', userId: 'u7', courseId: 'c5', completedAt: '2026-06-15T15:00:00Z' },
  { lessonId: 'l5-3', userId: 'u7', courseId: 'c5', completedAt: '2026-06-16T16:00:00Z' },
  { lessonId: 'l5-4', userId: 'u7', courseId: 'c5', completedAt: '2026-06-17T17:00:00Z' },
  { lessonId: 'l5-5', userId: 'u7', courseId: 'c5', completedAt: '2026-06-18T18:00:00Z' },
  // Course 7 progress
  { lessonId: 'l7-1', userId: 'u1', courseId: 'c7', completedAt: '2026-06-20T10:00:00Z' },
  { lessonId: 'l7-2', userId: 'u1', courseId: 'c7', completedAt: '2026-06-21T11:00:00Z' },
  { lessonId: 'l7-1', userId: 'u3', courseId: 'c7', completedAt: '2026-06-20T14:00:00Z' },
  { lessonId: 'l7-2', userId: 'u3', courseId: 'c7', completedAt: '2026-06-21T15:00:00Z' },
  { lessonId: 'l7-3', userId: 'u3', courseId: 'c7', completedAt: '2026-06-22T16:00:00Z' },
  { lessonId: 'l7-4', userId: 'u3', courseId: 'c7', completedAt: '2026-06-23T17:00:00Z' },
  { lessonId: 'l7-5', userId: 'u3', courseId: 'c7', completedAt: '2026-06-24T18:00:00Z' }
]

// Make data reactive for Vue 2
const state = Vue.observable({
  courses: courses,
  users: users,
  progress: progressEntries,
  nextCourseId: 9,
  nextLessonId: 100
})

// ---------- Helper Functions ----------

function generateCourseId() {
  return `c${state.nextCourseId++}`
}

function generateLessonId() {
  return `l-gen-${state.nextLessonId++}`
}

function getCourseById(courseId) {
  return state.courses.find(c => c._id === courseId) || null
}

function getUserById(userId) {
  return state.users.find(u => u._id === userId) || null
}

function isLessonCompleted(courseId, lessonId, userId) {
  return state.progress.some(
    p => p.courseId === courseId && p.lessonId === lessonId && p.userId === userId
  )
}

function getCourseProgress(courseId, userId) {
  const course = getCourseById(courseId)
  if (!course) return 0
  const totalLessons = course.lessons.length
  if (totalLessons === 0) return 0
  const completedLessons = course.lessons.filter(l =>
    isLessonCompleted(courseId, l._id, userId)
  ).length
  return Math.round((completedLessons / totalLessons) * 100)
}

function getCompletedLessonsCount(courseId, userId) {
  const course = getCourseById(courseId)
  if (!course) return 0
  return course.lessons.filter(l =>
    isLessonCompleted(courseId, l._id, userId)
  ).length
}

function markLessonComplete(courseId, lessonId, userId) {
  if (isLessonCompleted(courseId, lessonId, userId)) return
  state.progress.push({
    lessonId,
    userId,
    courseId,
    completedAt: new Date().toISOString()
  })
}

function markLessonIncomplete(courseId, lessonId, userId) {
  const idx = state.progress.findIndex(
    p => p.courseId === courseId && p.lessonId === lessonId && p.userId === userId
  )
  if (idx > -1) {
    state.progress.splice(idx, 1)
  }
}

function addCourse(courseData) {
  const newCourse = {
    _id: generateCourseId(),
    title: courseData.title,
    description: courseData.description,
    category: courseData.category,
    difficulty: courseData.difficulty,
    instructor: courseData.instructor,
    thumbnail: courseData.thumbnail || '',
    createdAt: new Date().toISOString(),
    enrolledUsers: [],
    lessons: []
  }
  state.courses.push(newCourse)
  return newCourse
}

function updateCourse(courseId, courseData) {
  const course = getCourseById(courseId)
  if (!course) return null
  Object.assign(course, {
    title: courseData.title,
    description: courseData.description,
    category: courseData.category,
    difficulty: courseData.difficulty,
    instructor: courseData.instructor,
    thumbnail: courseData.thumbnail || course.thumbnail
  })
  return course
}

function deleteCourse(courseId) {
  const idx = state.courses.findIndex(c => c._id === courseId)
  if (idx > -1) {
    state.courses.splice(idx, 1)
    // Also remove progress entries for this course
    state.progress = state.progress.filter(p => p.courseId !== courseId)
  }
}

function addLesson(courseId, lessonData) {
  const course = getCourseById(courseId)
  if (!course) return null
  const newLesson = {
    _id: generateLessonId(),
    title: lessonData.title,
    description: lessonData.description,
    videoUrl: lessonData.videoUrl || 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
    duration: lessonData.duration || '10:00',
    order: course.lessons.length + 1
  }
  course.lessons.push(newLesson)
  return newLesson
}

function updateLesson(courseId, lessonId, lessonData) {
  const course = getCourseById(courseId)
  if (!course) return null
  const lesson = course.lessons.find(l => l._id === lessonId)
  if (!lesson) return null
  Object.assign(lesson, {
    title: lessonData.title,
    description: lessonData.description,
    videoUrl: lessonData.videoUrl || lesson.videoUrl,
    duration: lessonData.duration || lesson.duration
  })
  return lesson
}

function deleteLesson(courseId, lessonId) {
  const course = getCourseById(courseId)
  if (!course) return
  const idx = course.lessons.findIndex(l => l._id === lessonId)
  if (idx > -1) {
    course.lessons.splice(idx, 1)
    // Re-order remaining lessons
    course.lessons.forEach((l, i) => { l.order = i + 1 })
    // Remove progress entries for this lesson
    state.progress = state.progress.filter(p => !(p.courseId === courseId && p.lessonId === lessonId))
  }
}

function getLastActivity(courseId, userId) {
  const entries = state.progress.filter(p => p.courseId === courseId && p.userId === userId)
  if (entries.length === 0) return null
  const sorted = entries.sort((a, b) => new Date(b.completedAt) - new Date(a.completedAt))
  return sorted[0].completedAt
}

function getOverallStats() {
  const totalCourses = state.courses.length
  const totalLessons = state.courses.reduce((sum, c) => sum + c.lessons.length, 0)
  const enrolledUserIds = new Set()
  state.courses.forEach(c => c.enrolledUsers.forEach(uid => enrolledUserIds.add(uid)))
  const totalEnrolled = enrolledUserIds.size

  // Average completion across all enrolled user-course pairs
  let totalPercent = 0
  let pairCount = 0
  state.courses.forEach(c => {
    c.enrolledUsers.forEach(uid => {
      totalPercent += getCourseProgress(c._id, uid)
      pairCount++
    })
  })
  const avgCompletion = pairCount > 0 ? Math.round(totalPercent / pairCount) : 0

  return { totalCourses, totalLessons, totalEnrolled, avgCompletion }
}

function getUserProgressTable() {
  const rows = []
  state.courses.forEach(course => {
    course.enrolledUsers.forEach(uid => {
      const user = getUserById(uid)
      if (!user) return
      const completed = getCompletedLessonsCount(course._id, uid)
      const total = course.lessons.length
      const percent = total > 0 ? Math.round((completed / total) * 100) : 0
      const lastAct = getLastActivity(course._id, uid)
      rows.push({
        userName: user.name,
        userEmail: user.email,
        department: user.department,
        userId: uid,
        courseId: course._id,
        courseTitle: course.title,
        completedLessons: completed,
        totalLessons: total,
        progress: percent,
        lastActivity: lastAct
      })
    })
  })
  return rows
}

// Categories and difficulties constants
const CATEGORIES = ['Compliance', 'Product Training', 'Soft Skills', 'Technical']
const DIFFICULTIES = ['Beginner', 'Intermediate', 'Advanced']

export {
  state,
  CATEGORIES,
  DIFFICULTIES,
  getCourseById,
  getUserById,
  isLessonCompleted,
  getCourseProgress,
  getCompletedLessonsCount,
  markLessonComplete,
  markLessonIncomplete,
  addCourse,
  updateCourse,
  deleteCourse,
  addLesson,
  updateLesson,
  deleteLesson,
  getLastActivity,
  getOverallStats,
  getUserProgressTable
}
